import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Right: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWall2Right"><Path fillRule="evenodd" clipRule="evenodd" d="M21 4V20H19.5V12.3106L14.5 17.3107L13.4393 16.25L16.9393 12.75H3V11.25H16.9393L13.4393 7.75L14.5 6.68934L19.5 11.6893V4H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Right;
